export const toastMessageMotion = {
  initial: { opacity: 0, x: 50, scale: 0.3 },
  animate: { opacity: 1, x: 0, scale: 1 },
  exit: { opacity: 0, scale: 0 },
};
